import { toast } from 'react-toastify';

export const generateStorePlacesQuery = (
  listType,
  tags,
  selectedEstablishment,
  selectedStore,
  selectedProduct,
  formCard,
  appliedFilters
) => {
  const result = {
    systemQuery: {},
    geoRadius: appliedFilters?.geoRadius,
    orderType: formCard.orderType,
  };

  // Define o orderType baseado no listType
  if (listType === 'proximos_mim') {
    result.orderType = 'location'; // Força 'location' para 'proximos_mim'
  }

  // Lógica para os diferentes tipos de listagem
  switch (listType) {
    case 'proximos_mim':
      result.systemQuery.grupo1 = [
        {
          field: 'endereco',
          type: '!=',
          value: 'Brasil',
        },
      ];
      break;

    case 'selecionados_tag':
      if (!result.systemQuery.grupo1) {
        result.systemQuery.grupo1 = [];
      }
      result.systemQuery.grupo1.push({
        field: 'tags',
        type: 'array_contains',
        value: tags,
      });
      break;

    case 'selecionados_unitariamente':
      // Lógica para seleção unitária
      let fieldName;
      let value;

      switch (formCard.action) {
        case 'establishment_list':
          fieldName = 'establishmentId';
          value = selectedEstablishment?.id;
          break;
        case 'promotion_list':
          fieldName = 'id';
          value = selectedStore?.id;
          break;
        case 'product_list':
          fieldName = 'id';
          value = selectedProduct?.id;
          break;
        default:
          break;
      }

      if (value) {
        if (!result.systemQuery.grupo1) {
          result.systemQuery.grupo1 = [];
        }
        result.systemQuery.grupo1.push({
          field: fieldName,
          type: '==',
          value: value,
        });
      }
      break;

    case 'pointsback':
      // Garante que grupo1 existe (cria se não existir)
      if (!result.systemQuery.grupo1) {
        result.systemQuery.grupo1 = [];
      }
      result.systemQuery.grupo1.push({
        field: 'tags',
        type: 'array_contains',
        value: ['awin'],
      });
      break;
  }

  // Adiciona campos específicos baseados no tipo de ação
  switch (formCard.action) {
    case 'establishment_list':
      if (appliedFilters?.hasPromo === true) {
        result.hasPromo = appliedFilters.hasPromo;
      }
      break;
    case 'promotion_list':
      // Só adiciona hasVoucher se for true
      if (appliedFilters?.hasVoucher === true) {
        result.hasVoucher = appliedFilters.hasVoucher;
      }
      break;
    default:
      break;
  }

  // Remove systemQuery se estiver vazio
  if (Object.keys(result.systemQuery).length === 0) {
    delete result.systemQuery;
  }

  return { storePlacesQuery: result };
};

export const verifyURL = (input) => {
  // Expressão regular para validar uma URL
  let regex = new RegExp(
    '^(https?:\\/\\/)?(www\\.)?' + // Protocolo (opcional) e "www" (opcional)
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}(\\.br)?)|' + // Domínio com ou sem o .br
      '((\\d{1,3}\\.){3}\\d{1,3})' + // Ou endereço IP
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // Porta e caminho
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // Parâmetros
      '(\\#[-a-z\\d_]*)?$',
    'i'
  );

  return regex.test(input);
};

export const validateForm = (data, cardType, url, setErrorUrl, setLoading) => {
  const requiredFields = [
    data.title !== '',
    cardType !== '',
    cardType === 'card_list' || data.action !== '',
    data.description !== '',
    data.images.web !== '',
    data.images.mobile !== '',
    data.images.mobileDetails !== '',
  ];

  if (requiredFields.some((field) => !field)) {
    toast.error('Todos os dados devem ser preenchidos corretamente.');
    setLoading(false);
    return false;
  }

  if (cardType === 'card_url') {
    try {
      const validateUrl = new URL(data.appFilter.url);
      const splitUrl = validateUrl.origin.split('.');
      const isUrl = verifyURL(url);
      if (splitUrl.length < 2 || data.appFilter.url === '' || !isUrl) {
        setErrorUrl(true);
        return false;
      }
    } catch (error) {
      setErrorUrl(true);
      return false;
    }
  }

  return true;
};
